module.exports = __webpack_public_path__ + "static/media/4-b.330b68b6.png";